import React, { Component } from 'react'
import AudioPlayer, { VOLUME_CONTROLS } from 'react-h5-audio-player'
import './MusicPlayer.css'
import playlist from './music-list.js'
import {
	MusicButton,
	MusicPlayerVolumeAdjust,
} from '../../../utils/Analytics.js'
import { getCurrentScene } from '../../../utils/History'
import { storeId } from '../../../../../variables/Variables'
import { exhibitStoreId, isExhibit, popupStoreId } from '../../../utils/StoreConfigManager'
import { MediaContext } from '../MediaContext'
import { isMobileDevice } from '../../../utils/DeviceDetector'

const defaultTopColor = 'white'
const defaultBottomColor = 'white'
const IS_MUSIC_PAUSE = 'isMusicPause'
const MUSIC_VOLUME = 'musicVol'
const MUSIC_CURRENT_TIME = 'musicData'
const rooms = [
	[
		'spring',
		'spring-rhs',
		'spring-lhs',
		'spring-rhs-shelf',
		'spring-lhs-shelf',
	],
	['summer', 'summer-rhs', 'summer-lhs'],
	[
		'holiday',
		'holiday-womens',
		'holiday-mens',
		'holiday-rhs-shelf',
		'holiday-lhs-shelf',
	],
	['denim', 'denim-rhs', 'denim-lhs', 'denim-rhs-back', 'denim-lhs-back'],
	['responsible-living', 'responsible-living-lhs'],
	['accessories', 'accessories-rhs', 'accessories-lhs'],
	['jungle'],
	['garage'],
	['sand'],
	['road'],
	['art'],
	['nature'],
	['view-1'],
	['view-2', 'view-3', 'view-4', 'view-5', 'view-6', 'view-7', 'view-8'],
]

class MusicPlayer extends Component {
	audioRef

	constructor(props) {
		super(props)
		this.state = {
			musiclist: [],
			musicVolume: 0.15,
			audioVolume: 1.5,
			currentMusicIndex: 0,
			isMusicList: true,
			isAudioOn: false,
			loop: false,
			scene: '',
			previouslyOn: false,
			previosPath: '',
			musicAutoPlayed: false,
			currentTime: 0,
			audioBarStyle: {
				backgroundImage:
					'linear-gradient(-135deg, ' +
					defaultTopColor +
					' 0%, ' +
					defaultBottomColor +
					' 100%)',
			},
		}
	}

	componentDidMount() {
		const { mediaVolume } = this.props
		if (localStorage.getItem(IS_MUSIC_PAUSE) == null) {
			this.setLocalValue(false)
		}
		this.detechUrlChange()
		this.setState({
			audioVolume: mediaVolume,
			musicVolume: mediaVolume * 0.1,
		})

		if (isMobileDevice()) {
			window.addEventListener('touchend', this.onInteracted)
		} else {
			window.addEventListener('click', this.onInteracted)
		}
	}

	onInteracted = () => {
		const condition = !(
			!this.state.musicAutoPlayed && !this.getLocalValue()
		)
		if (!this.state.musicAutoPlayed && !!this.getLocalValue()) {
			this.playMusic()
		}
	}

	setLocalValue = (value) => {
		localStorage.setItem(IS_MUSIC_PAUSE, value)
	}

	getLocalValue = () => {
		return localStorage.getItem(IS_MUSIC_PAUSE)
	}

	detechUrlChange() {
		setTimeout(() => {
			this.setMusicList()
			this.setIsAudioOn()
		}, 1000)
	}

	setMusicList = () => {
		let musicList = []
		if (
			typeof playlist['nature'] != 'undefined' &&
			playlist['nature'].length > 0
		) {
			if (storeId === exhibitStoreId) {
				this.setState({ isMusicList: false })
			} else {
				musicList = playlist['nature']
				const isLoop = musicList.length === 1
				this.setState({
					musiclist: musicList,
					isMusicList: true,
					loop: isLoop,
				})
			}
		} else {
			this.setState({ isMusicList: false })
		}
	}

	handleClickPrevious = () => {
		this.setState((prevState) => ({
			currentMusicIndex:
				prevState.currentMusicIndex === 0
					? this.state.musiclist.length - 1
					: prevState.currentMusicIndex - 1,
		}))
	}

	handleClickNext = () => {
		this.setState((prevState) => ({
			currentMusicIndex:
				prevState.currentMusicIndex < this.state.musiclist.length - 1
					? prevState.currentMusicIndex + 1
					: 0,
		}))
	}

	componentDidUpdate(prevProps) {
		if (
			this.props.mediaContext.isVideoPlaying !==
			prevProps.mediaContext.isVideoPlaying
		) {
			if (this.props.mediaContext.isVideoPlaying) {
				if (!this.state.isAudioOn) {
					this.setState({ previouslyOn: false })
					return
				}
				this.setState({ previouslyOn: true })
				this.toggleMusic()
			} else {
				if (this.state.previouslyOn) {
					this.audioRef.audio.current.play()
					this.setState({
						isAudioOn: true,
					})
					this.setLocalValue(false)
				}
			}
		}
	}

	changeVolume = (e) => {
		this.audioRef.audio.current.volume = e.target.value * 0.1
		this.setState({
			audioVolume: e.target.value,
			musicVolume: e.target.value * 0.1,
		})

		MusicPlayerVolumeAdjust()
	}

	playMusic = () => {
		this.audioRef?.audio.current.play()
		this.setState({
			isAudioOn: true,
			musicAutoPlayed: true,
		})
		this.setLocalValue(false)
		!isExhibit && MusicButton(true)
	}

	pauseMusic = () => {
		this.audioRef.audio.current.pause()
		this.setState({
			isAudioOn: false,
		})
		this.setLocalValue(true)
		!isExhibit && MusicButton(false)
	}

	toggleMusic = () => {
		if (this.audioRef.audio.current.paused) {
			this.playMusic()
		} else {
			this.pauseMusic()
		}
	}

	setIsAudioOn = () => {
		const isPause = this.getLocalValue()
		if (this.audioRef) {
			if (isPause === 'true') {
				this.setState({
					isAudioOn: false,
				})
				setTimeout(() => {
					this.audioRef.audio.current.pause()
				}, 500)
			} else {
				this.audioRef.audio.current.play()
				if (!this.audioRef.audio.current.paused) {
					this.setState({
						isAudioOn: true,
					})
				}
			}
		}
	}

	render() {
		const {
			currentMusicIndex,
			musiclist,
			audioVolume,
			audioBarStyle,
			isAudioOn,
			isMusicList,
			musicVolume,
			loop,
		} = this.state
		const { showMediaTitle } = this.props
		let className = isAudioOn ? 'audio-bar audio-on' : 'audio-bar audio-off'
		const audioPlayer =
			(musiclist.length && isMusicList) > 0 ? (
				<div className='otbmusicPlayer' id='otbmediaPlayer'>
					<div className='otbAudioPlayer'>
						<div
							id='audio-bar-container'
							onClick={this.toggleMusic}
						>
							<div
								id='audio-bar-1'
								className={className}
								style={audioBarStyle}
							/>
							<div
								id='audio-bar-2'
								className={className}
								style={audioBarStyle}
							/>
							<div
								id='audio-bar-3'
								className={className}
								style={audioBarStyle}
							/>
						</div>
						<div className='otbAudioPlayerfull'>
							{showMediaTitle && (
								<div className='otbPlayerList'>
									<p className='otbCurrentSong'>
										{' '}
										{musiclist[currentMusicIndex].name}{' '}
										{musiclist[currentMusicIndex].artist ? (
											<span className='otbCurrentSongArtist'>
												{' '}
												{'- ' +
													musiclist[currentMusicIndex]
														.artist}
											</span>
										) : (
											<></>
										)}
									</p>
								</div>
							)}
							<AudioPlayer
								ref={(ref) => (this.audioRef = ref)}
								autoPlayAfterSrcChange={true}
								showSkipControls={true}
								showJumpControls={false}
								volume={musicVolume}
								src={musiclist[currentMusicIndex].src}
								onClickPrevious={this.handleClickPrevious}
								onClickNext={this.handleClickNext}
								onEnded={this.handleClickNext}
								customControlsSection={['VOLUME_CONTROLS']}
								customProgressBarSection={[]}
								customAdditionalControls={[]}
								customVolumeControls={[
									<input
										className='vmControl'
										type='range'
										min='0'
										max='10'
										onChange={(e) => this.changeVolume(e)}
										value={audioVolume}
										ref={(ref) =>
											(this.audioControlRef = ref)
										}
										id='your-custom-id'
									/>,
								]}
								autoPlay={isAudioOn}
								preload={'auto'}
								loop={loop}
							/>
						</div>
					</div>
				</div>
			) : (
				<React.Fragment />
			)

		return <div className='roomOtbPlayer'>{audioPlayer}</div>
	}
}

export default (props) => (
	<MediaContext.Consumer>
		{(mediaContextValue) => (
			<MusicPlayer mediaContext={mediaContextValue} {...props} />
		)}
	</MediaContext.Consumer>
)
